import request from "./request";
import apis from "./apis";

const {
  departmentInfo,
} = apis.department;

const department = {
  getDepartmentInfo: () => {
    return request.get(departmentInfo);
  },
  createDepartmentInfo: (data: Object) => {
    return request.post(departmentInfo, data);
  },
  updateDepartmentInfo: (data: Object) => {
    return request.put(departmentInfo, data);
  },
  deleteDepartmentInfo: (id: Object) => {
    return request.delete(departmentInfo, id);
  },
};

export default department;